import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useCart } from '../../context/CartContext';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { ShoppingCart, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ product, currentCategory }) => {
  const { t } = useLanguage();
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const monthlyPayment = product.monthly_payment;
  const isAvailable = product.available !== false; // Default to true if not set

  const handleAddToCart = (e) => {
    e.stopPropagation();
    if (isAvailable) {
      addToCart(product);
    }
  };

  const handleViewDetails = () => {
    // Navigate with state to remember the category
    navigate(`/product/${product.id}`, {
      state: { fromCategory: currentCategory || product.category }
    });
  };

  return (
    <Card 
      className="group overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-lg relative"
      onClick={handleViewDetails}
    >
      <div className="relative aspect-square flex items-center justify-center bg-white p-4 rounded-xl">
        <img
          src={product.image}
          alt={product.name}
          className="object-contain object-center w-full h-full transition-transform duration-500 group-hover:scale-105"
        />
        {product.featured && (
          <Badge className="absolute top-3 right-3 bg-primary">
            <Sparkles className="h-3 w-3 mr-1" />
            {t('featured')}
          </Badge>
        )}
        
        {/* Unavailability Badge */}
        {!isAvailable && (
          <div className="absolute inset-0 bg-black/5 backdrop-blur-[2px] flex items-center justify-center rounded-xl">
            <Badge 
              variant="destructive" 
              className="bg-red-500/90 backdrop-blur-sm text-white px-4 py-2 text-sm font-medium shadow-lg"
            >
              Actualmente no disponible
            </Badge>
          </div>
        )}
      </div>
      
      <CardContent className="p-6 space-y-4">
        {/* Brand */}
        <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          {product.brand}
        </div>

        {/* Product Name */}
        <h3 className="text-lg font-semibold leading-tight line-clamp-2 min-h-[3.5rem]">
          {product.name}
        </h3>

        {/* Pricing */}
        <div className="space-y-1">
          <div className="text-2xl font-bold">
            RD${product.price.toLocaleString()}
          </div>
          <div className="text-sm text-muted-foreground">
            {t('from')} <span className="font-semibold text-foreground">RD${monthlyPayment.toLocaleString()}</span>{t('perMonth')}
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-2">
          <Button 
            className="flex-1"
            onClick={handleAddToCart}
            disabled={!isAvailable}
          >
            <ShoppingCart className="h-4 w-4 mr-2" />
            {t('addToCart')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
